<template>
  <div class="login-page container-fluid min-vh-100">
    <div class="row min-vh-100 align-items-center">

      <!-- COLUNA ESQUERDA -->
      <div class="col-12 col-lg-8 d-flex align-items-center justify-content-center">
        <div class="login-card w-100 mx-auto">

          <router-link to="/login" class="voltar mb-4 d-inline-flex align-items-center">
            ← Voltar
          </router-link>

          <!-- LOGO -->
          <div class="mb-4 d-flex align-items-center gap-2">
            <img src="../img/logotipo-icon.png" height="38" />
          </div>

            <!-- ETAPA 1 -->
            <form v-if="etapa === 1" @submit.prevent="enviarCodigo">
            <!-- TÍTULO -->
            <div class="page-header mb-4">
              <p class="page-header-eyebrow">SEGURANÇA</p>
              <h1 class="page-title mb-1">Recuperar senha</h1>
            </div>
            <p class="page-subtitle mb-4">
              Digite seu e-mail de cadastro para recuperar sua conta
            </p>
            <label class="form-label">E-mail *</label>
            <div class="campo-senha mb-4">
              <img src="../img/email-icon.png" class="icone" />
              <input
                type="email"
                class="form-control"
                placeholder="Digite seu e-mail"
                v-model="email"
                required
              />
            </div>

            <button class="btn btn-primary botao-azul w-100">
              Enviar código
            </button>
          </form>

          <!-- ETAPA 2 -->
          <form v-if="etapa === 2" @submit.prevent="validarCodigo">
            <!-- TÍTULO -->
            <div class="page-header mb-4">
              <p class="page-header-eyebrow">SEGURANÇA</p>
              <h1 class="page-title mb-1">Insira o código</h1>
            </div>
            <p class="page-subtitle mb-4">
              Enviamos um código de 6 dígitos para seu e-mail
            </p>

            <div class="codigo-container mb-4">
              <input
                v-for="(n, i) in codigo"
                :key="i"
                maxlength="1"
                class="form-control text-center codigo"
                v-model="codigo[i]"
                @input="focarProximo(i)"
                required
              />
            </div>

            <p class="text-muted mb-4" style="font-weight: 400;">
              Não recebeu o código? <a href="#" @click.prevent="reenviarCodigo" class="link-azul">Reenviar código</a>
            </p>

            <button class="btn btn-primary botao-azul w-100">
              Avançar
            </button>
          </form>

          <!-- ETAPA 3 -->
          <form v-if="etapa === 3" @submit.prevent="definirNovaSenha">

            <!-- TÍTULO -->
            <div class="page-header mb-4">
              <p class="page-header-eyebrow">SEGURANÇA</p>
              <h1 class="page-title mb-1">Definir nova senha</h1>
            </div>

            <label class="form-label">Nova senha</label>
            <div class="campo-senha mb-3">
              <img src="../img/block-blue-icon.png" class="icone" />
              <input
                :type="mostrarSenha ? 'text' : 'password'"
                class="form-control input-senha"
                v-model="senha"
                required
              />
              <img
                src="../img/eye-icon.png"
                class="icone olho"
                @click="mostrarSenha = !mostrarSenha"
              />
            </div>

            <label class="form-label">Confirmar senha</label>
            <div class="campo-senha mb-4">
              <img src="../img/block-blue-icon.png" class="icone" />
              <input
                :type="mostrarConfirmarSenha ? 'text' : 'password'"
                class="form-control input-senha"
                v-model="confirmarSenha"
                required
              />
              <img
                src="../img/eye-icon.png"
                class="icone olho"
                @click="mostrarConfirmarSenha = !mostrarConfirmarSenha"
              />
            </div>

            <button class="btn btn-primary botao-azul w-100">
              Alterar senha
            </button>
          </form>

        </div>
      </div>

      <!-- COLUNA DIREITA -->
        <div class="col-lg-4 d-none d-lg-flex login-banner p-0">
        <img
            src="../img/banner.svg"
            class="login-banner-img"
            alt="Banner"
        />
        </div>

    </div>

    <!-- MODAIS -->
    <AlertModal
      :visible="alertModal.visible"
      :title="alertModal.title"
      :message="alertModal.message"
      :type="alertModal.type"
      @close="fecharAlert"
    />

    <LoadingModal
      :visible="loading.visible"
      :title="loading.title"
      :message="loading.message"
    />

  </div>
</template>

<script>

import AlertModal from '@/componentesTelas/AlertModal.vue';
import LoadingModal from '@/componentesTelas/LoadingModal.vue';

export default {
  name: "RecuperarSenha",

  data() {
    return {
      etapa: 1, // 1=email | 2=código | 3=nova senha
      email: "",
      codigo: ["", "", "", "", "", ""],
      senha: "",
      confirmarSenha: "",
      mostrarSenha: false,
      mostrarConfirmarSenha: false,

      // Modal genérico
      alertModal: {
        visible: false,
        title: '',
        message: '',
        type: 'info'
      },

      loading: {
        visible: false,
        title: 'Aguarde',
        message: 'Estamos processando sua solicitação...'
      },
    };
  },

  components: {
    AlertModal,
    LoadingModal
  },

  mounted() {
    const emailSalvo = localStorage.getItem("email_lembrado");

    if (emailSalvo) {
        this.email = emailSalvo;
        this.lembrarSenha = true;
    }
  },

  methods: {

    abrirAlert(title, message, type = 'info') {
      this.alertModal = {
        visible: true,
        title,
        message,
        type
      };
    },

    fecharAlert() {
      this.alertModal.visible = false;
    },

    abrirLoading(title, message) {
      this.loading = {
        visible: true,
        title,
        message
      };
    },

    fecharLoading() {
      this.loading.visible = false;
    },

    // Input do código
    focarProximo(i) {
      if (this.codigo[i] && i < 5) {
        this.$el.querySelectorAll('input')[i + 1].focus();
      }
    },

    // ETAPA 1
    async enviarCodigo() {
      this.abrirLoading('Enviando código', 'Estamos enviando o código para seu e-mail...');

      try {
        const response = await fetch(
          `${process.env.VUE_APP_BACKEND_URL}/recuperar-senha/enviar-codigo`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ email: this.email })
          }
        );

        if (!response.ok) {
          this.abrirAlert("Sistema", "E-mail não encontrado.", "error");
          return;
        }

        this.etapa = 2;
      } finally {
        this.fecharLoading();
      }
    },

    // ETAPA 2
    async reenviarCodigo() {
      this.abrirLoading('Reenviando código', 'Estamos enviando um novo código para seu e-mail...');

      try {
        const response = await fetch(
          `${process.env.VUE_APP_BACKEND_URL}/recuperar-senha/enviar-codigo`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ email: this.email })
          }
        );

        if(response.ok){
          this.abrirAlert("Sistema", "Código reenviado com sucesso!", "success");
        }

        if (!response.ok) {
          this.abrirAlert("Sistema", "E-mail não encontrado.", "error");
          return;
        }

        this.etapa = 2;
      } finally {
        this.fecharLoading();
      }
    },

    async validarCodigo() {
      const codigoFinal = this.codigo.join("");
      this.abrirLoading('Validando código', 'Estamos conferindo o código informado...');

      try {
        const response = await fetch(
          `${process.env.VUE_APP_BACKEND_URL}/recuperar-senha/validar-codigo`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              email: this.email,
              codigo: codigoFinal
            })
          }
        );

        if (!response.ok) {
          this.abrirAlert("Sistema", "Código inválido.", "error");
          return;
        }

        this.etapa = 3;
      } finally {
        this.fecharLoading();
      }
    },

    // ETAPA 3
    async definirNovaSenha() {
      if (this.senha.length < 8) {
        this.abrirAlert("Sistema", "A senha deve ter no mínimo 8 caracteres.", "error");
        return;
      }

      if (this.senha !== this.confirmarSenha) {
        this.abrirAlert("Sistema", "As senhas não coincidem.", "error");
        return;
      }

      this.abrirLoading('Alterando senha', 'Estamos atualizando sua senha...');

      try {
        const response = await fetch(
          `${process.env.VUE_APP_BACKEND_URL}/recuperar-senha/definir-senha`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              email: this.email,
              senha: this.senha
            })
          }
        );

        if (!response.ok) {
          this.abrirAlert("Sistema", "Erro ao redefinir senha.", "error");
          return;
        }

        this.abrirAlert("Sistema", "Senha alterada com sucesso!", "success");
        this.$router.push("/login");
      } finally {
        this.fecharLoading();
      }
    }

  }
};
</script>


<style>

.campo-senha {
  position: relative;
}

.campo-senha .icone {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  width: 18px;
  opacity: 0.7;
  pointer-events: none;
}

.input-senha,
.campo-senha input {
  padding-left: 42px;
}

.campo-senha .icone.olho {
  left: auto;
  right: 12px;
  cursor: pointer;
  pointer-events: auto;
}

.login-page {
  background: #ffffff;
}

.login-page a {
  color: #0056ff;
  font-weight: 700;
}

.login-card {
  max-width: 420px;
  padding: 32px;
}

.login-card .page-header {
  margin-bottom: 8px;
}

.voltar {
  color: #0056ff;
  text-decoration: none;
  font-weight: 500;
}

.voltar:hover {
  text-decoration: underline;
}

.btn-login {
  background: #0056ff;
  border-radius: 8px;
  font-weight: 700;
  padding: 12px;
}

.btn-login:hover {
  background: #000;
}

/* BANNER DIREITO */
.login-banner {
  height: 100vh;
  justify-content: flex-end;
}

.login-banner-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

@media (min-width: 768px) and (max-width: 991.98px) {
  .login-card {
    max-width: 720px !important;
  }
}

@media (max-width: 575.98px) {
  .login-card {
    padding: 24px 20px;
  }
}

.texto-azul {
  color: #0056ff;
}

.codigo{
  flex: 0 0 52px !important;
  width: 52px !important;
  height: 60px;
  min-width: 52px !important;
  max-width: 52px !important;
  box-sizing: border-box;
  padding: 0 !important;
  font-size: 18px;
  font-weight: 600;
}

.codigo-container {
  display: flex !important;
  flex-wrap: nowrap;
  gap: 8px;
  width: max-content;
  max-width: 100%;
  margin-right: auto;
  margin-left: auto;
}

@media screen and (max-width: 576px) {
  .codigo {
    flex-basis: 47px !important;
    width: 47px !important;
    min-width: 47px !important;
    max-width: 47px !important;
  }

  .codigo-container {
    gap: 6px;
  }
}

</style>